import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { Channel } from '@rikstv/play-common/src/forces/channels/channel.types';
import { Gutter, Loader, SecondaryButton } from '@rikstv/shared-components';

import { commonRouterPaths } from '../../../router/router.path';
import { Section } from '../../section/Section';
import { TvGuideChannel } from '../TvGuideChannel';
import { TvGuideContext } from '../TvGuideContext';
import { useTvGuideChannels } from '../useTvGuideChannels';

import styles from './TvGuideMini.module.css';

interface Props {
  currentChannel?: Channel;
}

export const TvGuideMini: FC<Props> = ({ currentChannel }) => {
  const navigate = useNavigate();
  const { channels } = useTvGuideChannels({ includePrograms: false });

  const displayChannels = channels
    ?.slice()
    .sort(c => (String(c.channelId) === currentChannel?.id ? -1 : 0))
    .slice(0, 4);

  return (
    <TvGuideContext.Provider value={{ channels: displayChannels || [], selectedDate: new Date() }}>
      {!channels && <Loader size="large" />}
      <Gutter>
        <Section type="transparent">
          <div className={styles.commonMiniTvGuideContent}>
            {displayChannels &&
              displayChannels.map(channel => (
                <div key={channel.channelId}>
                  <TvGuideChannel
                    displayEarlierProgramsCount={0}
                    channel={channel}
                    maxPrograms={5}
                    showFullDayButton={false}
                    isMiniTVGuide={true}
                  />
                </div>
              ))}
          </div>
        </Section>
      </Gutter>
      <div className={styles.tvGuideLink}>
        <SecondaryButton onClick={() => navigate(commonRouterPaths.tvGuide)}>Til hele TV-Guiden</SecondaryButton>
      </div>
    </TvGuideContext.Provider>
  );
};
